import { ClienteInterface } from "../../../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";
import { FormatterCPF } from "../../../../../Validations/InputMasks";

interface IClientesRowProps {
    row: ClienteInterface;
}

export default function ClientesRow(props: IClientesRowProps) {
    const cliente = props.row;

    return (
        <div
            key={cliente.ID_CONTA}
            className="card card-custom cliente-card cursor-pointer"
        >
            <div className="card-body pt-3 pb-3">
                <div className="d-flex ">
                    <div className="flex-grow-1">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <div className="mr-3">
                                <span className="d-flex align-items-center text-dark text-hover-primary font-size-h2 font-weight-bold mr-3">
                                    {cliente.DS_CONTA}
                                    <i className="flaticon2-correct text-success icon-md ml-2"></i>
                                </span>
                                <div className="d-flex flex-wrap my-2">
                                    {cliente.NR_CPF && (
                                        <span className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                            <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                                <i className="far fa-address-card"></i>
                                            </span>
                                            {FormatterCPF(cliente.NR_CPF)}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
